module.exports = __webpack_public_path__ + "static/media/mieko_perez.69e63bcb.jpg";